import { createBulkMutationHook, createDefaultMutationHook } from "hooks/useMutationHandler";

import { STACK_LOCK } from "./gql";

const useLockStack = createDefaultMutationHook(STACK_LOCK);
export const useBulkLockStack = createBulkMutationHook(STACK_LOCK);

export default useLockStack;
